import React from 'react';
import { useTitle } from 'react-use';

type HeadTitleProps = {
    children: string;
};

const HeadTitle = (props: HeadTitleProps): null => {
    const { children } = props;

    useTitle(children, { restoreOnUnmount: true });

    return null;
};

export { HeadTitle };
